import { render, staticRenderFns } from "./FlexmessageEdit.vue?vue&type=template&id=4f9cfe2a&"
import script from "./FlexmessageEdit.vue?vue&type=script&lang=js&"
export * from "./FlexmessageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports